import AuthenticationService from "./../../services/AuthenticationService";
import alerts from "@/components/alerts/alert";
import confirmations from "./confirmations";
import Api from "@/api";
import store from "@/store";

const users = {
  namespaced: true,
  state: {
    all: [],
    datas: {},
    loading: false,
    label: "Create",
    modal: false,
    role: null,
    form: {},
    queryParam: null,
    activationData: null,
    activationModal: false,
    modalCreate: false,
    modalEdit: false,
    admins: [],
    register: {},
  },
  getters: {
    getData(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_DATAS(state, data) {
      state.datas = data;
    },
    SET_ALL(state, data) {
      state.all = data;
    },
    SET_ACTIVATION_DATA(state, data) {
      state.activationData = data;
    },
    SET_ACTIVATION_MODAL(state, data) {
      state.activationModal = data;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
    SET_FORM(state, data) {
      state.form = data;
    },
    SET_LABEL(state, data) {
      state.label = data;
    },
    SET_MODAL_CREATE(state, data) {
      state.modalCreate = data;
    },
    SET_ADMIN(state, data) {
      state.admins = data;
    },
    SET_MODAL_EDIT(state, data) {
      state.modalEdit = data;
    },
  },
  actions: {
    async all({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doPaginate("users").then(({ data }) => {
        commit("SET_ALL", data);
        commit("SET_LOADING", false);
      });
    },
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("users/page", payload).then(({ data }) => {
        commit("SET_DATAS", data);
        commit("SET_LOADING", false);
      });
    },
    async paginateAdmin({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("users/admin/page", payload).then(
        ({ data }) => {
          commit("SET_ADMIN", data);
          commit("SET_LOADING", false);
        }
      );
    },
    onAction({ commit, state }, payload) {
      if (payload[1] === "Create") {
        commit("SET_MODAL_CREATE", true);
        state.register = {};
      } else if (payload[1] === "Detail") {
        commit("SET_DETAIL", payload[0]);
        commit("SET_MODAL_DETAIL", true);
      } else if (payload[1] === "Edit") {
        state.register = payload[0];
        commit("SET_MODAL_EDIT", true);
      }
    },
    onRefresh({ state }) {
      store.dispatch("users/page", {
        loading: true,
        datas: state.queryParam,
      });
    },
    onRefreshAdmin({ state }, payload) {
      store.dispatch("users/paginateAdmin", state.queryParam);
    },
    async reqDataUsers({ commit }, payload) {
      commit("SET_LOADING", payload);
      return await Api.doGet("users").then(({ data }) => {
        commit("SET_DATAS", data);
        commit("SET_LOADING", false);
      });
    },
    async setActive({ commit }, payload) {
      const params = {
        id: payload[1],
        active: payload[0],
      };
      return await AuthenticationService.put(
        "users/set-active/" + payload[1],
        params
      ).then(({ data }) => {
        commit("SET_LOADING", false);
        alerts.sweetalertToast(
          data.code === 200 ? "success" : "error",
          data.message
        );
      });
    },
    confirmationSave() {
      confirmations.confirmationForm("users/save");
    },
    confirmation({ commit }, payload) {
      confirmations.confirmationForm(payload[0], `users/${payload[1]}`);
    },
    async create({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.postFormData("users", state.register)
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("users/onRefresh");
        })
        .catch((error) => {
          if (error.response.data.code === 400) {
            store.dispatch("errors/setError", error.response.data.errors);
          }
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async update({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.postFormData(
        "users/update/" + payload.user_id,
        state.register
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_EDIT", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("users/onRefreshAdmin");
        })
        .catch((error) => {
          if (error.response.data.code === 400) {
            store.dispatch("errors/setError", error.response.data.errors);
          }
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async save({ state }) {
      store.dispatch("loading/setLoading", true);
      try {
        if (state.label === "Create") {
          return await AuthenticationService.post(
            "users/create",
            state.form
          ).then(({ data }) => {
            store.dispatch("loading/setLoading", false);
            state.datas.push(state.form);
            if (data.code === 200) {
              store.dispatch("users/all", false);
              state.modal = false;
            }
            alerts.sweetalertToast(
              data.code === 200 ? "success" : "error",
              data.message
            );
          });
        } else if (state.label === "Update") {
          return await AuthenticationService.post(
            "users/update/" + state.form.id,
            state.form
          ).then(({ data }) => {
            store.dispatch("loading/setLoading", false);
            if (data.code === 200) {
              store.dispatch("users/all", false);
              state.modal = false;
            }
            alerts.sweetalertToast(
              data.code === 200 ? "success" : "error",
              data.message
            );
          });
        } else if (state.label === "Delete") {
          return await Api.doDelete("users/delete/" + state.form.id).then(
            ({ data }) => {
              store.dispatch("loading/setLoading", false);
              if (data.code === 200) {
                const index = state.datas.findIndex(
                  (item) => item.id === state.form.id
                );
                state.datas.splice(index, 1);
                store.dispatch("users/all", false);
              }
              alerts.sweetalertToast(
                data.code === 200 ? "success" : "error",
                data.message
              );
            }
          );
        }
      } catch (error) {
        store.dispatch("loading/setLoading", false);
        alerts.sweetalertToast("error", error.message);
      }
    },
    // onAction({ commit, state }, payload) {
    //   commit("SET_LABEL", payload[1]);
    //   commit("SET_FORM", payload[0]);
    //   if (payload[1] === "Delete") {
    //     confirmations.confirmationDelete("users/save");
    //   } else {
    //     state.modal = true;
    //   }
    // },
    onInputImage({ state }, payload) {
      state.form[payload[1]] = payload[0];
    },
  },
};

export default users;
